<template><div><h1>VUX V2.5.7 发布日志</h1>
<h2><a href="/zh-CN/components/checklist.html">Checklist</a></h2>
<ul><li>[feature] 支持在 on-change 事件中附带 `label` 值 #1783</li>
</ul>
<h2><a href="/zh-CN/components/confirm.html">Confirm</a></h2>
<ul><li>[feature] 支持 prop:input-attrs 设置额外属性 #1799</li>
</ul>
<h2><a href="/zh-CN/components/loading.html">Loading</a></h2>
<ul><li>[fix] 修复 vue@2.4 no setter 警告，可以直接用 :show 绑定 #1798</li>
</ul>
<h2><a href="/zh-CN/components/panel.html">Panel</a></h2>
<ul><li>[feature] 属性使用 v-html 绑定 #1784</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] 修复修改值后第二次打开默认选中项渲染不正确的问题 #1793</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.7 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.7-249.vue?2fe0fea4